import { Stack } from 'react-bootstrap';

export function NotFoundPage() {
    return (
        <div className="px-4 pt-4">
            <Stack>
                <h1>Not Found</h1>
                <div>The page you are looking for has moved or no longer exists.</div>
            </Stack>
        </div>
    );
}
